import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { initLocale } from './i18n';
import './styles/globals.css';

// Apply the saved theme before first paint — the login page lives outside the
// app shell, where useTheme() never runs, so <html> would otherwise keep the
// build-time class and ignore the user's choice.
const storedTheme = localStorage.getItem('license-dashboard.theme');
const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
const effectiveTheme =
  storedTheme === 'light'
    ? 'light'
    : storedTheme === 'system'
      ? prefersDark
        ? 'dark'
        : 'light'
      : 'dark';
document.documentElement.classList.toggle('dark', effectiveTheme === 'dark');

// Resolve the locale (saved choice > server DEFAULT_LOCALE > 'en') before first paint.
void initLocale().finally(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});
